import Axios from 'axios'
import { getHeaders } from '@/utils/api'

export default {
  methods: {
    getRequestInfo () {
      this.headers = getHeaders(this.$store.getters.getToken)
      this.instanceUrl = this.$store.getters.getActiveInstance.url
      return {
        headers: this.headers,
        instanceUrl: this.instanceUrl
      }
    },
    async checkCityModel () {
      let isCity = true
      this.getRequestInfo()

      try {
        await Axios.get(`${this.instanceUrl}cities?page_size=1`, { headers: this.headers })
      } catch (error) {
        // cities model doesn't exist.
        isCity = false
      }
      this.isCityModel = isCity
      return isCity
    },
    async getCityById (id) {
      let info = this.getRequestInfo()
      try {
        let response = await Axios.get(`${info.instanceUrl}cities/${id}`, { headers: info.headers })
        if (response.status >= 200 && response.status < 300) {
          let { data } = response
          return (data.name)
        } else {
          return false
        }
      } catch (error) {
        console.log(error)
        return false
      }
    },
    async getCityByNameAndState (name, state) {
      let info = this.getRequestInfo()
      try {
        let response = await Axios.get(`${info.instanceUrl}cities?search=${name}&state=${state}`, {headers: info.headers})
        if (response.status >= 200 && response.status < 300) {
          let { data } = response
          if (data.count > 0) {
            return data.results[0].id
          } else {
            return false
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async addNewCity (payload) {
      let info = this.getRequestInfo()
      try {
        let response = await Axios.post(`${info.instanceUrl}cities`, payload, { headers: info.headers })
        return response.data.id
      } catch (error) {
        console.log(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/CityMixin.js